export default "__VITE_PUBLIC_ASSET__454f463a__"